var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1Way(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#673ab7",
    d: "M4.13923 3.4339C2.88014 3.4339 1.86115 4.50222 1.86115 5.80795L1.8522 20.05C1.8522 21.3616 2.87665 22.4263 4.14147 22.4263H6.4285V27.1744L11.007 22.4263H22.4534C23.7125 22.4263 24.7426 21.358 24.7426 20.0523V5.80795C24.7426 4.50222 23.7125 3.4339 22.4534 3.4339H4.13923ZM7.57313 9.36903H15.5856V11.8706L19.0195 9.36903V16.4912L15.5856 13.9896V16.4912H7.57313V9.36903Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Way);
export default __webpack_public_path__ + "static/media/1way.2023099485eab7bd5bf3fc12cd4f749f.svg";
export { ForwardRef as ReactComponent };